import { StyleSheet } from 'aphrodite';
import { hexToRgbA } from 'util/styleUtil';
import typography from 'defaults/typography';

const getSkin = (theme) => {
    const globalProfiles = theme.globalProfiles;
	const skin = globalProfiles.palette;
	const myTypography = typography(theme);

    return StyleSheet.create({
		initiativeValue: {
			...myTypography.number,
			fontStyle: 'normal',
			fontWeight: 600,
			fontSize: '16px',
			color: skin.black,
			'@media (min-width: 1440px)' : {
				fontSize: '18px',
			},
			'@media (min-width: 1600px)' : {
				fontSize: '20px',
			},
			'@media (min-width: 1920px)' : {
				fontSize: '24px',
			},
			'@media (min-width: 2560px)' : {
				fontSize: '32px',
			},
		},
		headerTitle: {
			...myTypography.body2,
			color: skin.grayColor2,
			fontWeight: 600,
		},
		actionName: {
			...myTypography.body1,
			color: skin.grayColor1,
			fontWeight: 600,
		},
		expectedIn: {
			...myTypography.body2,
			color: skin.grayColor2,
		},
		days: {
			...myTypography.body2,
			color: skin.grayColor1,
			fontWeight: 600,
		}
	});
}

export default getSkin;